import { Button, Grid, Modal as MuiModal, Typography } from "@mui/material";
import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ClearIcon } from "@mui/x-date-pickers/icons";

interface Props {
  unsavedChanges: boolean;
}

const UnsavedChangesModal: React.FC<Props> = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [unsavedModalOpen, setUnsavedModalOpen] =
    React.useState<boolean>(false);
  const [nextLocation, setNextLocation] = React.useState<string>(null);
  const [allowNavigation, setAllowNavigation] = React.useState<boolean>(false);

  React.useEffect(() => {
    const unblock = history.block((nextLocaltion) => {
      if (!props.unsavedChanges || allowNavigation) {
        return true; // Allow navigation
      } else {
        setNextLocation(nextLocaltion);
        setUnsavedModalOpen(true);
        return false; // Block navigation
      }
    });

    return () => {
      unblock();
    };
  }, [props.unsavedChanges, allowNavigation, location]);

  React.useEffect(() => {
    if (allowNavigation && nextLocation) {
      history.push(nextLocation);
    }
  }, [allowNavigation, nextLocation]);

  const confirmOnSaveModal = () => {
    setUnsavedModalOpen(false);
    setAllowNavigation(true);
  };

  return (
    <MuiModal open={unsavedModalOpen} className="modal-primary">
      <div className="paper" style={{ width: 430 }}>
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className="main-header" style={{ marginBottom: "20px" }}>
                <span>Unsaved Changes</span>
                <span
                  id="dismiss-button"
                  onClick={() => setUnsavedModalOpen(false)}
                >
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: "24px",
                paddingRight: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "#1E1E1E",
                }}
              >
                Are you sure you want to leave this section? There are some
                unsaved changes.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="modal-footer"
          >
            <Grid item xs={12} className="confirm-btn-container">
              <div
                onClick={() => setUnsavedModalOpen(false)}
                className="cancel-link"
              >
                Cancel
              </div>
              <Button
                onClick={confirmOnSaveModal}
                className="confirm-btn"
                style={{ width: 156 }}
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </MuiModal>
  );
};

export default UnsavedChangesModal;
